/* eslint-disable react/jsx-no-useless-fragment */
import React, { Fragment } from 'react';
import { node, shape, string } from 'prop-types';
import classNames from 'classnames';
import 'styles/Layout.scss';

const Container = ({
  style,
  className,
  children,
  ...rest
}) => (
  <div style={style} className={classNames('layout-container', className)} {...rest}>
    {children}
  </div>
);

Container.defaultProps = {
  children: <Fragment />,
  className: null,
  style: {},
};

Container.propTypes = {
  style: shape({}),
  className: string,
  children: node,
};

export default Container;
